import {shapeTypeConst} from '../../conf';
import {idUtil} from '../../../../../static/scripts/util';
import {nodeCore} from '../../core/logic';

/**
 * 拓扑插件-内置图形属性
 */

export const attrArray = [
  initNodeAttr({
    elementId: '1604678934442553390',
    label: '矩形',
    type: shapeTypeConst.rect,
    iconContent: 'tp-icon-node-ju-xing',
    size: [140, 80]
  }),
  initNodeAttr({
    elementId: '1604678934442553391',
    label: '圆角矩形',
    type: shapeTypeConst.rect,
    iconContent: 'tp-icon-node-yuan-jiao-ju-xing',
    size: [140, 80],
    style: initNodeStyle({radius: 6})
  }),

  initNodeAttr({
    elementId: '1604678934442553392',
    label: '正方形',
    type: shapeTypeConst.rect,
    iconContent: 'tp-icon-node-zheng-fang-xing'
  }),

  initNodeAttr({
    elementId: '1604678934446747649',
    label: '圆形',
    type: shapeTypeConst.circle,
    iconContent: 'tp-icon-node-zheng-yuan'
  }),

  initNodeAttr({
    elementId: '1604678934446747650',
    label: '椭圆形',
    type: shapeTypeConst.ellipse,
    iconContent: 'tp-icon-node-tuo-yuan',
    size: [140, 80]
  }),

  initNodeAttr({
    elementId: '1604678934446747651',
    label: '三角形',
    type: shapeTypeConst.triangle,
    iconContent: 'tp-icon-node-zheng-san-jiao',
    size: [40, 50]
  }),

  

  initNodeAttr({
    elementId: '1604679887493308440',
    label: '图片一',
    type: shapeTypeConst.customImage,
    iconContent: require('../../../assets/images/san-ceng-jiao-huan-ji.svg')
  }),
  initNodeAttr({
    elementId: '1604679887493308441',
    label: '图片二11111',
    type: shapeTypeConst.image,
    iconContent: require('../../../assets/images/zhu-ji.svg')
  })
];


/**
 * 拓扑插件-根据组件标识初始化监视器列表
 * @param identity 组件标识
 * @returns attr 监视器列表
 */
export function initJobAttrArray(identity) {
  const identityConf = {
    'tp_job_kylin': {label: '麒麟', elementId: '1603681393831866370', iconContent: 'tp-icon-node-qi-lin'},
    'tp_job_linux': {label: 'Linux', elementId: '1603681393831866371', iconContent: 'tp-icon-node-linux'},
    'tp_job_windows': {label: 'Windows', elementId: '1603681393831866372', iconContent: 'tp-icon-node-windows'},
    'tp_job_one_exchange': {label: '一层交换机', elementId: '1603681903750168590', iconContent: 'tp-icon-node-jiao-huan-ji'},
    'tp_job_two_exchange': {label: '二层交换机', elementId: '1603681903750168591', iconContent: 'tp-icon-node-jiao-huan-ji'},
    'tp_job_three_exchange': {label: '三层交换机', elementId: '1603681903750168592', iconContent: 'tp-icon-node-jiao-huan-ji'},
    'tp_job_mysql': {label: 'MySql', elementId: '1603682813930905620', iconContent: 'tp-icon-node-mysql'},
    'tp_job_da_meng': {label: '达梦数据库', elementId: '1603682813930905621', iconContent: 'tp-icon-node-da-meng'},
    'tp_job_gbase8s': {label: 'GBase8s军用版', elementId: '1603682813930905622', iconContent: 'tp-icon-node-gbase-2'},
    'tp_job_king_base': {label: '人大金仓', elementId: '1603682813930905623', iconContent: 'tp-icon-node-king-base'},
    'tp_job_shen_tong': {label: '神通数据库', elementId: '1603682813930905624', iconContent: 'tp-icon-node-shen-tong'},
    'tp_job_oracle': {label: 'Oracle', elementId: '1603682813930905625', iconContent: 'tp-icon-node-oracle'},
    'tp_job_tong_web': {label: '东方通', elementId: '1603683912347836440', iconContent: 'tp-icon-node-tongweb'},
    'tp_job_tomcat': {label: 'Tomcat', elementId: '1603683912347836441', iconContent: 'tp-icon-node-tomcat'},
    'tp_job_apusic': {label: '金蝶', elementId: '1603683912347836442', iconContent: 'tp-icon-node-apusic'},
    'tp_job_kafka': {label: 'Kafka', elementId: '1603683912347836443', iconContent: 'tp-icon-node-kafka'},
    'tp_job_rabbit_mq': {label: 'RabbitMQ', elementId: '1603683912347836444', iconContent: 'tp-icon-node-rabbit-mq'},
    'tp_job_rocket_mq': {label: 'RocketMQ', elementId: '1603683912347836445', iconContent: 'tp-icon-node-rocket-mq'},
    'tp_job_active_mq': {label: 'ActiveMQ', elementId: '1603683912347836446', iconContent: 'tp-icon-node-active-mq'}
  };

  const conf = identityConf[identity];
  if (conf) {
    const num = (10 + Math.round(Math.random() * (100 - 10)));
    const array = [];
    for (let i = 0; i < num; i++) {
      const ipOne = (2 + Math.round(Math.random() * (255 - 2)));
      const ipTwo = (2 + Math.round(Math.random() * (255 - 2)));
      array.push(initNodeAttr({
        id: idUtil.getIdStr(),
        // elementId: conf?.elementId,
        label: conf?.label + i,
        type: shapeTypeConst.iconFont,
        iconContent: conf?.iconContent,
        jobId: idUtil.getIdStr(),
        ipAddress: '172.16.' + ipOne + '.' + ipTwo
      }));
    }
    return array;
  }
  return null;
}



/**
 * 初始化节点属性
 * @param options 扩展参数
 * @returns style 节点默认属性
 */
export function initNodeAttr(options) {
  const conf = {
    // 必填项，String型，节点唯一 ID，必须是唯一的 string
    id: '',
    // 非必填，Number型，x 坐标
    x: 0,
    // 非必填，Number型，y 坐标
    y: 0,
    // 非必填，String型，指定节点类型，内置节点类型名称或自定义节点的名称。默认为 'circle'
    type: 'circle',
    // 非必填，Number|Array型，节点的大小
    size: 60,
    // 非必填，Array型，指定边连入节点的连接点的位置（相对于该节点而言），可以为空。例如: [0, 0]，代表节点左上角的锚点，[1, 1],代表节点右下角的锚点
    anchorPoints: [
      [0, 0],
      [0, 0.5],
      [0, 1],
      [0.5, 0],
      [0.5, 1],
      [1, 0],
      [1, 0.5],
      [1, 1]
    ],
    // 非必填，Object型，节点的样式属性。
    style: initNodeStyle(),
    // 非必填，String型，文本文字
    label: '',
    // 非必填，Object型，文本配置项
    labelCfg: initNodeLabelCfg(),

    // 自定义属性
    // 监视器ID
    jobId: '',
    // 监视器IP地址
    ipAddress: '',
    // 节点状态（1正常，默认、2节点告警，黄色、3节点故障，红色、4节点不存在）
    nodeStatus: 1,
    // 图标资源路径或字体图标class名
    iconContent: '',
    // 图标字体
    iconFontFamily: 'LeTpFont'
  };

  if (options) {
    Object.assign(conf, options);
    // 处理节点配置中各类自定义参数
    nodeCore.handleNodeAttr(conf);
  }
  return conf;
}


/**
 * 初始化节点样式参数
 * @param options 扩展参数
 * @returns style 节点默认参数
 */
export function initNodeStyle(options) {
  // 非必填，Object型，节点的样式属性。
  const conf = {
    // 非必填，String型，节点填充色
    fill: 'rgba(48, 161, 255, 1)',
    // 非必填，String型，节点的描边颜色
    stroke: '#666',
    // 非必填，Number型，描边宽度
    lineWidth: 0,
    // 非必填，Number[]型，描边虚线，数组代表实、虚长度
    lineDash: [],
    // 非必填，String型，阴影颜色
    shadowColor: '',
    // 非必填，Number型，阴影范围
    shadowBlur: 0,
    // 非必填，Number型，阴影 x 方向偏移量
    shadowOffsetX: 0,
    // 非必填，Number型，阴影 y 方向偏移量
    shadowOffsetY: 0,
    // 非必填，Number型，设置绘图的当前 alpha 或透明值
    opacity: 1,
    // 非必填，Number型，设置填充的 alpha 或透明值
    // fillOpacity: 1,
    // 非必填，String型，鼠标在该节点上时的鼠标样式，CSS 的 cursor 选项都支持
    // cursor: '',
    // 设置描边的 alpha 或透明值，优先级高于 opacity，范围 [0, 1]
    strokeOpacity: 1
  };

  if (options) {
    Object.assign(conf, options);
  }
  return conf;
}


/**
 * 初始化节点文字标签参数
 * @param position 文本相对节点位置
 * @param offset 文本偏移量
 * @param options 扩展参数
 * @returns attr 文字标签默认参数
 */
export function initNodeLabelCfg(position, offset, options) {
  const conf = {
    // 非必填，String型，文本颜色
    fill: '#333',
    // 非必填，String型，文本描边颜色
    stroke: '',
    // 非必填，Number型，文本描边粗细
    lineWidth: 0,
    // 非必填，Number型，文本透明度
    opacity: 1,
    // 非必填，String型，文本字体
    fontFamily: '微软雅黑',
    // 非必填，Number型，文本字体大小
    fontSize: 14,
    // 设置文本内容的当前对齐方式
    textAlign: 'center',
    // 非必填，String型，阴影颜色
    shadowColor: '',
    // 非必填，Number型，阴影范围
    shadowBlur: 0,
    // 非必填，Number型，阴影 x 方向偏移量
    shadowOffsetX: 0,
    // 非必填，Number型，阴影 y 方向偏移量
    shadowOffsetY: 0
  };

  if (options) {
    Object.assign(conf, options);
  }

  return {
    // 非必填，String型，文本相对于节点的位置，目前支持的位置有：'center'，'top'，'left'，'right'，'bottom'。默认为 'center'。modelRect 节点不支持该属性
    position: position || 'bottom',
    // 	非必填，Number型，文本的偏移，position 为 'bottom' 时，文本的上方偏移量；position 为 'left' 时，文本的右方偏移量；以此类推在其他 position 时的情况。modelRect 节点的 offset 为左边距
    offset: offset || 5,
    // 非必填，Object型，标签的样式属性。
    style: conf
  };
}
